import clipboard from '@assets/analytics/clipboard.svg?raw';
import helmet from '@assets/analytics/helmet.svg?raw';
import clock from '@assets/analytics/clock.svg?raw';
import calendarPlus from '@assets/analytics/calendar-plus.svg?raw';
import calendar from '@assets/analytics/calendar.svg?raw';
import route from '@assets/analytics/route.svg?raw';
import pin from '@assets/analytics/pin.svg?raw';
import scissorsLift from '@assets/analytics/scissors-lift.svg?raw';
import tag from '@assets/analytics/tag.svg?raw';
import edit from '@assets/analytics/edit.svg?raw';
import userWithCross from '@assets/analytics/user-with-cross.svg?raw';

export type ICardIconName =
  | 'clipboard'
  | 'helmet'
  | 'clock'
  | 'calendar-plus'
  | 'calendar'
  | 'Route'
  | 'pin'
  | 'scissors-lift'
  | 'tag'
  | 'edit'
  | 'user-with-cross';

/**
 * Local fallback when the trusstor `trusstor-icons` S3 bucket doesn't
 * have the asset for this dev env (the storage proxy 404s). Vendored
 * shapes from the trusstor repo so the page still renders correctly.
 */
export const LOCAL_FALLBACK: Record<ICardIconName, string> = {
  clipboard,
  helmet,
  clock,
  'calendar-plus': calendarPlus,
  calendar,
  Route: route,
  pin,
  'scissors-lift': scissorsLift,
  tag,
  edit,
  'user-with-cross': userWithCross,
};

/**
 * Re-paint every coloured `fill` / `stroke` to `currentColor` so the
 * inline SVG inherits its colour from the parent (the yellow header,
 * via `color: var(--navy)`). `fill="none"` is preserved so outline-
 * only shapes stay outlines.
 */
export function recolor(svg: string): string {
  return svg.replace(
    /(fill|stroke)="((?!none\b)[^"]+)"/g,
    (_match, attr: string) => `${attr}="currentColor"`,
  );
}
